module.exports = __webpack_public_path__ + "static/media/Egress.c18f826e.svg";